import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
/* empty css           */
const LiveLabel = () => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("span", { className: "omega_iconLiveWithDot", children: t("LIVE") });
};
export {
  LiveLabel
};
//# sourceMappingURL=index.js.map
